import { render, staticRenderFns } from "./UserViewUserInfoCard.vue?vue&type=template&id=95927c00"
import script from "./UserViewUserInfoCard.vue?vue&type=script&lang=js"
export * from "./UserViewUserInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports